<script lang="ts">
    import type { Interval } from './Segments.types';

    interface Props {
        segment: Interval | undefined;
    }

    let { segment }: Props = $props();
</script>

{#if segment}
    <li class="reptile-segment-interval">
        <span>...</span>
    </li>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-segment-interval {
        float: left;
        min-width: 30px;
        font-weight: normal;
        text-align: center;
        line-height: 34px;
        padding: 0 tokens.$oc-semantic-spacing-50;
    }
</style>
